module.exports = __webpack_public_path__ + "img/photo2_2.9134b352.jpg";